import Image from "next/image"
import CustomButton from "../shared/CustomButton"
import useMediaGetter from "@/app/hooks/useMediaGetter"
import { useNavigation } from "@/app/hooks/useNavigation"

const formatDate = (dateString?: string) => {
	if (!dateString) return ""
	const date = new Date(dateString)
	return date.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "long",
		year: "numeric",
	})
}

const ConstructionCard = ({ data, setActiveModal, setModalData }: any) => {
	const { imgSrc } = useMediaGetter(data?.media.filter((item: any) => item?.pivot?.slug == null))
	const router = useNavigation()
	return (
		<div className="mb-[3rem] lg:mb-0">
			<div
				className={`relative 
        h-[17rem] 
        mb-6
		construction-updates-card
        ${data.index == 0 && "lg:h-[28rem]"}
        ${data.index == 1 && "lg:h-[35rem]"}
        ${data.index == 2 && "lg:h-[25rem]"}
        ${data.index == 3 && "lg:h-[21.5rem]"}
        ${data.index == 4 && "lg:h-[26.25rem]"}
        `}
			>
				{imgSrc && <Image src={`${imgSrc}`} alt="img" fill objectFit="cover" />}
			</div>
			<p className="text-bodyS font-national text-oBlack-60">{data.title}</p>
			<h4 className="text-bodyL my-4">
				{formatDate(data?.date)}
			</h4>
			<CustomButton
				text="Learn More"
				hasIcon
				style="grey"
				action={() => {
					setActiveModal(true)
					setModalData(data)
				}}
			/>
		</div>
	)
}

export default ConstructionCard
